import { ArrowRight } from 'lucide-react';
import AppLink from '@/components/AppLink/AppLink';
import productArticles from '@/pages/articles/productArticles.json';
import { routes } from '@/routes';

const HOMEPAGE_ARTICLES = productArticles.slice(0, 6);

/** The first six product articles, two per row, then a link to every article. */
export default function ArticleCards() {
  return (
    <section
      data-newsletter-section="articles"
      aria-labelledby="newsletter-articles-heading"
      className="border-y border-nl-line bg-nl-muted/40 px-6 py-20 md:py-28"
    >
      <div className="mx-auto max-w-6xl">
        <h2
          id="newsletter-articles-heading"
          className="h-display m-0 text-4xl leading-tight font-medium text-balance md:text-5xl"
        >
          Go deeper on any step.
        </h2>
        <ul role="list" className="mt-8 grid gap-x-8 gap-y-12 md:mt-12 md:grid-cols-2">
          {HOMEPAGE_ARTICLES.map(({ path, title, description, banner, bannerSrcSet }) => (
            <li key={path} className="group relative flex min-w-0 flex-col">
              <img
                src={banner}
                srcSet={bannerSrcSet}
                sizes="(min-width: 1200px) 560px, (min-width: 768px) calc((100vw - 80px) / 2), calc(100vw - 48px)"
                alt=""
                width={1280}
                height={720}
                loading="lazy"
                decoding="async"
                className="aspect-video h-auto w-full rounded-2xl border border-nl-line bg-nl-muted object-cover shadow-nl-pop transition-transform duration-fast group-hover:-translate-y-0.5 motion-reduce:transition-none motion-reduce:group-hover:translate-y-0"
              />
              <h3 className="h-display m-0 mt-5 text-2xl leading-tight font-medium text-balance">
                <AppLink
                  to={path}
                  className="after:absolute after:inset-0 after:rounded-2xl focus-visible:outline-none focus-visible:after:outline-2 focus-visible:after:outline-offset-4 focus-visible:after:outline-nl-ink"
                >
                  {title}
                </AppLink>
              </h3>
              <p className="m-0 mt-2 leading-relaxed text-nl-ink/70">{description}</p>
              <span
                aria-hidden="true"
                className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold underline-offset-4 group-hover:underline"
              >
                Read more
                <ArrowRight className="size-4" />
              </span>
            </li>
          ))}
        </ul>
        <AppLink
          to={routes.articles}
          className="mt-12 inline-flex min-h-12 items-center gap-2 rounded-full border border-nl-ink px-6 font-semibold text-nl-ink transition hover:bg-nl-ink/5 focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-nl-ink"
        >
          See all articles
          <ArrowRight className="size-4" aria-hidden="true" />
        </AppLink>
      </div>
    </section>
  );
}
